import React from "react";
import thunk from "redux-thunk";
import { Provider } from "react-redux";
import { createStore, applyMiddleware, compose } from "redux";
import { ConnectedRouter, connectRouter } from "connected-react-router";
import { Route, Switch, Redirect } from "react-router";
import { createHashHistory } from "history";

import rootReducer from "fantastic/reducers";
import Editor from "fantastic/components/Editor";
import FayeClient from "fantastic/components/FayeClient";
import Fail from "fantastic/components/Fail";
import Fonts from "shared/lib/Fonts";
import sections from "fantastic/lib/sections";

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const history = createHashHistory();

const App = ({ dataJson, updateCampaigns }) => {
  const data = JSON.parse(dataJson);
  const initialState = {
    ...data,
    sections: sections.prepare(data.sections),
    versions: {
      currentIndex: 0,
      sections: [JSON.stringify(data.sections)]
    }
  };
  const store = createStore(
    connectRouter(history)(rootReducer),
    initialState,
    composeEnhancers(applyMiddleware(thunk))
  );
  window.store = store;
  Fonts.load();

  return (
    <Provider store={store}>
      <div className="fantastic-app">
        <ConnectedRouter history={history}>
          <Switch>
            <Route
              exact
              path="/editor"
              render={props => <Editor history={history} settings={data.settings} />}
            />
            <Route
              path="/preview"
              render={props => <Editor history={history} preview />}
            />
            <Route path="/">
              <Redirect to="/editor" />
            </Route>
          </Switch>
        </ConnectedRouter>
        <FayeClient />
        <Fail />
      </div>
    </Provider>
  );
};

export default App;
